import React from "react";
import moment from "moment";
import { useTranslation } from "react-i18next";

const methodLabel = (method) => {
  if (method === "paypal") return "PayPal";
  if (method === "square" || method === "squareup") return "Square";
  if (method === "stripe") return "Stripe";
  return method || "";
};

export default function Confirmation({ event, userDetails, timeZoneName }) {
  const { t } = useTranslation("clientMisc");
  if (!event) return null;
  const start = moment(`${event.date} ${event.start_time}`, [
    "YYYY-MM-DD HH:mm",
    "YYYY-MM-DD hh:mm A",
  ]);
  const paid = Number(event.price) > 0;
  const languages = Array.isArray(event.languages)
    ? event.languages.join(", ")
    : event.languages;

  return (
    <div className="container se-confirm text-center">
      <div className="se-confirm-check">
        <span>&#10003;</span>
      </div>
      <h3 className="se-confirm-title">{t("specialEvents.confirm.title")}</h3>
      <div className="se-confirm-card">
        <p>
          <b>{t("specialEvents.confirm.event")}</b> {event.title}
          {languages ? ` (${languages})` : ""}
        </p>
        <p>
          <b>{t("specialEvents.confirm.type")}</b> {t("specialEvents.serviceLabel")}
        </p>
        <p>
          <b>{t("specialEvents.confirm.when")}</b> {start.format("ddd, MMM D")} &middot; {start.format("hh:mm A")} ({timeZoneName})
        </p>
        <p>
          <b>{t("specialEvents.confirm.paid")}</b>{" "}
          {paid
            ? userDetails && userDetails.method
              ? t("specialEvents.confirm.paidAmountVia", {
                  amount: Number(event.price).toFixed(2),
                  currency: event.currency || "USD",
                  method: methodLabel(userDetails.method),
                })
              : t("specialEvents.confirm.paidAmount", {
                  amount: Number(event.price).toFixed(2),
                  currency: event.currency || "USD",
                })
            : t("specialEvents.confirm.freeEvent")}
        </p>
        <p className="mb-0">
          <b>{t("specialEvents.confirm.sentTo")}</b> {userDetails && userDetails.email}
        </p>
      </div>
      <p className="se-muted mt-3">
        {t("specialEvents.confirm.checkEmail")}
      </p>
      <a className="se-btn-tan se-confirm-continue" href="/">
        {t("specialEvents.confirm.continue")}
      </a>
    </div>
  );
}
